// Unversioned list of velocity featues for local web app development.
// Name: (e.g. TestWidgetsVelocity) should be same as defined in m_featureLookUp in hostapp:DashboardLib\VelocityApi.cpp
// Value: true: Enabled
//        false: Disabled
export const featureLookUp = new Map([
    // Defined as always true in App.tsx
    ["Feature_DynamicFeed", true],
    ["Feature_MultiAccount", true],
    ["Feature_SignedOutUser", true],
    ["Feature_ReauthRequiredUser", true],
    ["Feature_FullPageWebXT", true],
    ["Feature_AugmentedEntryPoint", false],
    ["Feature_AvoidRenderWhileHidden", false],
    ["Feature_Unify1SCall", false],
    ["Feature_AugmentedEntryPointBadging", false],
    ["Feature_FeedsBackgroundTask", false],
    ["Feature_FeedsRotation", false],
    ["Feature_ExpandedView", false],
    ["Feature_XamlWidgetPicker", false],
    ["Feature_PrefetchFeedContent", false],
    ["Feature_PrefetchPCS", false],
    ["Feature_AllowMultiInstanceWidgets", false],
    ["Feature_PinWidgetsFlyout", false],
    ["Feature_CacheWidgetRegistrations", false],
    ["Feature_DMA1POptimization", false],
    ["Feature_DMAEdgeUninstall", false],
    ["Feature_PinMigration", false],
    ["Feature_DMARestrictDataSharing", false],
    ["Feature_PlatformFeeds", false],
    ["Feature_3pPlatformFeeds", false],
    ["Feature_DMARestrictDiagnosticData", false],
    ["Feature_ProtocolLaunchCommandAPI", false],
    ["Feature_WebWidgetPrototype", false],
    ["Feature_WidgetHeaderUpdates", false],
    ["Feature_BoardsLite", false],
    ["Feature_PreDownloadInitializer", false],
]);
